import { faClock } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction } from "react";
import UnForm from "../../../../Components/Form";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import {
    ListarUsuariosAtivosComAcessoCasoController,
    RegistrarApontamentoDeHorasController,
} from "../../../../Controllers/AssistenciaTecnica/Atendimento/ApontamentoHoras/ApontamentoHorasController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { IApontamentoHoras } from "../../../../Interfaces/AssistenciaTecnica/Atendimento/ApontamentoHoras/ApontamentoHorasInterfaces";

interface IRegistrarApontamentoHorasProps {
    idTipoCaso: number;
    setShow: Dispatch<SetStateAction<boolean>>;
    updateList: () => void;
}

export default function RegistrarApontamentoHoras(
    props: IRegistrarApontamentoHorasProps
) {
    const { updateAtendimento, ID_CASO } = useAtendimentoPage();

    const { execute: executarFormManutencao, loading } = useAsyncCallback(
        RegistrarApontamentoDeHorasController
    );

    const handleCriarAtendimentoVinculadoFormSubmit = (
        formData: IApontamentoHoras
    ) => {
        executarFormManutencao({ ...formData, ID_CASO }).then(() => {
            updateAtendimento();
            props.updateList();
            props.setShow(false);
        });
    };

    return (
        <div>
            <UnForm handleSubmit={handleCriarAtendimentoVinculadoFormSubmit}>
                {
                    <>
                        <div className="mb-4">
                            <div className="row m-0">
                                <UnForm.Input
                                    name="DS_DURACAO"
                                    wrapperClassName="col-md-12"
                                    label="Hora Inicial"
                                    type={"time"}
                                    registerOptions={{
                                        required:
                                            "Insira a Duração Real do Reparo",
                                    }}
                                />
                            </div>
                        </div>

                        <div className="mb-8">
                            <div className="row m-0 ">
                                <UnForm.LazySelect
                                    controller={
                                        ListarUsuariosAtivosComAcessoCasoController
                                    }
                                    label="Atribuído a"
                                    name="ID_USUARIO"
                                    className={`form-control placeholder-dark-50`}
                                    wrapperClassName="col-12 col-md-12 m-0"
                                    getDS={(p) => p.DS_NOME}
                                    getKeyValue={(p) => p.ID_USUARIO}
                                >
                                    <option></option>
                                </UnForm.LazySelect>
                            </div>
                        </div>

                        <div className="mb-8">
                            <div className="row m-0 ">
                                <UnForm.Textarea
                                    name="DS_OBSERVACAO"
                                    label="Observação"
                                    noRezise
                                    rows={4}
                                    wrapperClassName="col-12 col-md-12 m-0"
                                />
                            </div>
                        </div>

                        <UnForm.SubmitButton
                            color="success"
                            wrapperClassName="w-100 mt-8"
                            className="w-100"
                            icon={faClock}
                            loading={loading}
                            disabled={loading}
                            loadingSize={"sm"}
                        >
                            Registrar Apontamento de Horas
                        </UnForm.SubmitButton>
                    </>
                }
            </UnForm>
        </div>
    );
}
